var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7808 20C16.4726 19.9992 16.1675 19.9372 15.8833 19.8178C15.5991 19.6984 15.3414 19.5238 15.125 19.3042L10 14.2092L4.87501 19.3075C4.54586 19.6414 4.12375 19.8685 3.66369 19.959C3.20363 20.0495 2.72696 19.9993 2.29584 19.815C1.86044 19.6399 1.48796 19.3375 1.22705 18.9474C0.966148 18.5573 0.828937 18.0976 0.833339 17.6283V4.16667C0.833339 3.0616 1.27233 2.00179 2.05373 1.22039C2.83513 0.438987 3.89494 0 5.00001 0L15 0C15.5472 0 16.089 0.107774 16.5945 0.317169C17.1 0.526563 17.5594 0.833478 17.9463 1.22039C18.3332 1.6073 18.6401 2.06663 18.8495 2.57215C19.0589 3.07768 19.1667 3.61949 19.1667 4.16667V17.6283C19.1713 18.0972 19.0346 18.5567 18.7743 18.9467C18.5141 19.3368 18.1423 19.6393 17.7075 19.815C17.414 19.9377 17.099 20.0006 16.7808 20ZM5.00001 1.66667C4.33696 1.66667 3.70108 1.93006 3.23224 2.3989C2.7634 2.86774 2.50001 3.50363 2.50001 4.16667V17.6283C2.49971 17.7672 2.54056 17.903 2.61742 18.0187C2.69428 18.1343 2.80369 18.2246 2.93183 18.2781C3.05997 18.3316 3.20109 18.3459 3.33737 18.3193C3.47365 18.2926 3.59897 18.2262 3.69751 18.1283L9.41667 12.4442C9.57281 12.289 9.78402 12.2018 10.0042 12.2018C10.2243 12.2018 10.4355 12.289 10.5917 12.4442L16.3042 18.1267C16.4027 18.2245 16.528 18.291 16.6643 18.3176C16.8006 18.3443 16.9417 18.33 17.0698 18.2765C17.198 18.2229 17.3074 18.1327 17.3843 18.017C17.4611 17.9014 17.502 17.7655 17.5017 17.6267V4.16667C17.5017 3.50363 17.2383 2.86774 16.7694 2.3989C16.3006 1.93006 15.6647 1.66667 15.0017 1.66667H5.00001Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "black"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.bb6cdfbb6ad35b67e35ecfaefb89bba7.svg";
export { ForwardRef as ReactComponent };